import BaseListStyle from "../../styles/BaseListStyle"; 

const CountryPermitRequirementsStyles = (theme) => { 
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
    checkbox: {
      minWidth: 120,
      margin: "0px 5px"
    },
    requirementsList: {
      "& .MuiTableHead-root": {
        display: "block",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
    },
    requirementsListEdit: {
      "& .MuiTableHead-root": {
        display: "table",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
    }, 
  }
}

export default CountryPermitRequirementsStyles;
